import React from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
interface PriceProps {
  amount: number;
  className?: string;
}
export function Price({
  amount,
  className = ''
}: PriceProps) {
  const {
    formatPrice,
    isLoading
  } = useCurrency();
  if (isLoading) {
    // Render a placeholder or the USD price while loading
    return <span className={className} data-id="element-2">${amount.toFixed(2)}</span>;
  }
  return <span className={className} data-id="element-3">{formatPrice(amount)}</span>;
}